import React from "react";
import { FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, useTheme, withStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { load } from "../../store/slices/configSlice";
import { getAllAreas } from "../../store/slices/salesAreaSlice";

const useStyles = makeStyles(theme => ({
  highlightSelected: {
    "& option:checked": {
        backgroundColor: 'green !important',
        color: 'white'
    },
  }
}));

function SalesAreaConfig(props) {
    const dispatch = useDispatch();
    let salesAreas = useSelector(getAllAreas)
    const classes = useStyles();
    const handleChangeMultiple = (key, event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {
                value.push(parseInt(options[i].value));
            }
        }
        let newConfig = JSON.parse(JSON.stringify(props.config));
        newConfig.SalesArea[key] = value
        dispatch(load(newConfig))
    };

    let salesAreaSize = salesAreas.length + 1;
    let selectedOnlySalesAreas = props.config.SalesArea && props.config.SalesArea.Only ? props.config.SalesArea.Only : [];

    return (
        <>
            <Grid item xs={12} sm={6}>
                <FormControl style={{width: "100%"}}>
                    <InputLabel shrink htmlFor="select-multiple-native">
                        ONLY dial these sales areas
                    </InputLabel>
                    <Select
                        className={classes.highlightSelected}
                        multiple
                        native
                        value={selectedOnlySalesAreas}
                        onChange={(e) => handleChangeMultiple("Only", e)}
                        inputProps={{
                            id: 'select-multiple-native',
                            size: salesAreaSize
                        }}
                        >
                            {
                                salesAreas.map(sa => {
                                    return (
                                        <option key={`dial-opt-${sa.Label}`} value={sa.ID}>
                                            {sa.Label}
                                        </option>
                                    )
                                })
                            }
                    </Select>
                </FormControl>
            </Grid>
        </>
    )
}

export default SalesAreaConfig;